import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Location } from '@angular/common';
import { AlertService, AuthenticationService, UserService } from '../_services';
import { Configuration } from '../configuration/configurations';
@Component({
    templateUrl: 'login.component.html'
    , providers: [Configuration]
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    forgotForm: FormGroup;
    loading = false;
    submitted = false;
    forgotsubmitted = false;
    returnUrl: string;
    islogin: boolean = true;
    isrestemail: boolean = true;
    password_type = 'password';
    dnsname: string;
    logoimage: string;
    isFromDns: boolean = false;
    private subhostname: any;
    private siteUrl: any = "";
    private themeWrapper = document.querySelector('body');
    ShowTaskTrack = true;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private userservice: UserService,
        private _configuration: Configuration, private location: Location
    ) { }

    ngOnInit() {

        this.loading = true;
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            recaptcha: ['', Validators.required]
            //password: ['', [Validators.required,Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
        });
        this.forgotForm = this.formBuilder.group({
            forgotEmail: ['', Validators.required],
            //recaptcha: ['', Validators.required]
            // resetrecaptcha: ['', Validators.required]
        });

        if (localStorage.getItem("TaskEnabled") != null) {
            this.ShowTaskTrack = localStorage.getItem("TaskEnabled") == 'Y' ? true : false;
        }

        
        localStorage.removeItem("PrimaryColor");
        localStorage.removeItem("SecondaryColor");
        localStorage.removeItem("BodyBackGround");
        localStorage.removeItem("DnsName");
        localStorage.removeItem("clientLogo");
        localStorage.removeItem("isfromDns");
        localStorage.removeItem("ReselerUrl");
        localStorage.removeItem("TaskEnabled");
        this.themeWrapper.classList.remove("bodybackground");
        this.themeWrapper.style.removeProperty('--colorPrimary');
        this.themeWrapper.style.removeProperty('--colorSecondary');
        // reset login status
        this.authenticationService.logout();

        this.dnsname = this.route.snapshot.queryParams['dns'];
        if (this._configuration._local) {
            this.siteUrl = new URL(this._configuration._subdomainhost);
        }
        else {
            this.siteUrl = window.location;
        }
        this.subhostname = this.siteUrl.host;
        let idx = this.subhostname.indexOf('.it');
        let sec = this.subhostname.substring(0, idx - 1).lastIndexOf('.');
        var rootDomain = this.subhostname.substring(sec + 1);
        this.subhostname = this.subhostname.replace(rootDomain, "");
        this.subhostname = this.subhostname.replace(".", "");
        if (this.subhostname != "") {
            if (this.subhostname != "www") {
                window.location.href = this._configuration.baseUrlToken + "/login";
            }

        }
        // if(this.route.snapshot.queryParams['dns']){
        // // this.userservice.GetClientDetailByDns(this.subhostname)
        //   this.userservice.GetClientDetailByDns(this.dnsname)
        //   .pipe(first()).subscribe(
        //       response => {
        //           let data=response["Data"];

        //                if(response["StatusCode"]=="200")
        //                {
        //                 this.isFromDns=true;

        //                   console.log("Client Dns Data",data["Data"]);
        //                   if(data["PrimaryColor"])
        //                   {
        //                     localStorage.setItem("PrimaryColor",data["PrimaryColor"])
        //                     this.themeWrapper.style.setProperty('--colorPrimary',data["PrimaryColor"] );
        //                   }
        //                   if(data["SecondaryColor"])
        //                   {
        //                     localStorage.setItem("SecondaryColor",data["SecondaryColor"])
        //                     this.themeWrapper.style.setProperty('--colorSecondary',data["SecondaryColor"] );
        //                   }

        //                   if(data["Logo"])
        //                   {
        //                       localStorage.setItem("clientLogo",data["Logo"]);
        //                       this.logoimage=data["Logo"];
        //                   }
        //                   localStorage.setItem("isfromDns","true");
        //                   localStorage.setItem("ReselerUrl",this.siteUrl.origin);
        //                   this.themeWrapper.classList.add("bodybackground");
        //                   localStorage.setItem("BodyBackGround","true");
        //                   localStorage.setItem("DnsName",data["DNS"]);
        //                   this.loading=false;
        //                }
        //               },
        //                error => {
        //               //         this.alertService.showNotification('error',"Some thing went wrong.")
        //                 //       this.loading = false;
        //                }
        //                );
        // }
        //this.loading=false;
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    focustext() {
        setTimeout(() => {
            document.getElementById('forgotemail').focus();
        }, 500);
    }
    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    get forgotForm_Control() { return this.forgotForm.controls; }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            if (this.f.recaptcha.invalid) {
                this.alertService.showNotification('error', 'Please verify captcha.');
            }
            return;
        }
        //this.loading = true;
        this.authenticationService.login(this.f.username.value.trim(), this.f.password.value.trim())
            .pipe(first()).subscribe(response => {
                if (response != null) {
                    console.log("doli", response);
                    localStorage.removeItem("PrimaryColor")
                    this.themeWrapper.style.removeProperty('--colorPrimary');
                    localStorage.removeItem("SecondaryColor")
                    this.themeWrapper.style.removeProperty('--colorSecondary');
                    localStorage.removeItem("clientLogo");
                    localStorage.setItem('currentUser', JSON.stringify(response));
                    debugger;
                    let access_token = response['access_token'];
                    let token_type = response['token_type'];
                    let expires_in = response['expires_in'];
                    let role = response['roleName'];
                    let user = response['User'];
                    let username = response['UserName'];
                    let displayname = response['DisplayName'];
                    let clientcode = response['ClientCode'];
                    let ClientName = response["ClientName"];
                    let rate = response['Rate'];
                    let Extensions = response["Extensions"];
                    let ServerId = response["ServerID"];
                    let clientlogo = response["Logo"];
                    let clientPrimaryColor = response["PrimaryColor"];
                    let clientSecondaryColor = response["SecondaryColor"];
                    let dnsName = response["DnsName"];
                    let TaskEnabled = response["TaskEnabled"];
                    console.log("Client Primary Color", clientPrimaryColor)
                    console.log("Client Secondary Color", clientSecondaryColor)
                    localStorage.setItem("Authorization", JSON.stringify(token_type + ' ' + access_token));
                    localStorage.setItem("role", role);
                    localStorage.setItem("user", user);
                    localStorage.setItem("userName", username);
                    localStorage.setItem("displayName", displayname);
                    localStorage.setItem("clientcode", clientcode);
                    localStorage.setItem("rate", rate);
                    localStorage.setItem("Extensions", Extensions);
                    localStorage.setItem("ClientName", ClientName);
                    localStorage.setItem("ServerId", ServerId)
                    localStorage.setItem("TaskEnabled", TaskEnabled)
                    if (clientPrimaryColor) {
                        localStorage.setItem("PrimaryColor", clientPrimaryColor)
                        //this.themeWrapper.style.setProperty('--bgPrimary',clientPrimaryColor);
                    }
                    if (clientSecondaryColor) {
                        localStorage.setItem("SecondaryColor", clientSecondaryColor)
                        //this.themeWrapper.style.setProperty('--bgSecondary',clientSecondaryColor);
                    }
                    if (clientlogo) {
                        localStorage.setItem("clientLogo", clientlogo);
                    }

                    localStorage.setItem("clientPrimaryColor", clientPrimaryColor);
                    localStorage.setItem("clientSecondaryColor", clientSecondaryColor);
                    // this.themeWrapper.style.setProperty('--bgPrimary',clientPrimaryColor);
                    this.islogin = true;
                    if (dnsName != "") {
                        let urlwithdns = this._configuration.baseUrlToken;
                        localStorage.setItem("isfromDns", "true");
                        localStorage.setItem("DnsName", dnsName);
                        urlwithdns = urlwithdns.replace("www", dnsName);
                        localStorage.setItem("ReselerUrl", urlwithdns);
                    }
                    if (localStorage.getItem("ReselerUrl")) {
                        //localStorage.setItem('currentUser', JSON.stringify(response));
                        window.location.href = localStorage.getItem("ReselerUrl") + "/dashboard?authdata=" + btoa(JSON.stringify(response));
                    }
                    else {
                        window.location.href = this._configuration.baseUrlToken + "/dashboard";
                    }

                    //this.router.navigate(['/revocodemo/dashboard']);
                }
                else {
                    this.islogin = false;
                    // this.loading = false;
                    this.alertService.showNotification('error', 'Email and password combination is incorrect.')
                }
            },
                error => {
                    //this.alertService.error(error);
                    this.alertService.showNotification('error', 'Email and password combination is incorrect.')
                    this.islogin = false;
                    //this.loading = false;
                });
    }

    onForgotSubmit() {
        this.forgotsubmitted = true;

        // stop here if form is invalid
        if (this.forgotForm.invalid) {
            if (this.f.recaptcha.invalid) {
                this.alertService.showNotification('error', 'Please verify captcha.');
            }
            return;
        } else {
            if (this.f.recaptcha.invalid) {
                this.alertService.showNotification('error', 'Please verify captcha.');
                return;
            }
        }
        let tempDnsName: string = "";
        if (localStorage.getItem("DnsName")) {
            tempDnsName = localStorage.getItem("DnsName");
        }
        else {
            tempDnsName = "Revoco";
        }


        this.authenticationService.forgotpassword(this.forgotForm_Control.forgotEmail.value.trim(), tempDnsName)
            .pipe(first()).subscribe(
                response => {
                    let data = response;
                    if (data["StatusCode"] == "200") {
                        this.isrestemail = true;
                        this.forgotForm_Control["forgotEmail"].setValue("");
                        this.alertService.showNotification('success', data["Message"])
                    }
                    else {
                        this.isrestemail = false;
                        this.alertService.showNotification('error', data["Message"])
                    }
                },
                error => {
                    this.alertService.showNotification('error', "Some thing went wrong.")
                    // this.loading = false;
                }
            );
    }
    changePasswordType() {
        this.password_type = this.password_type === 'text' ? 'password' : 'text';
    }
    hideError() {
        //this.msg = "";
        this.islogin = true;
    }
}
